import { render, staticRenderFns } from "./AnexoAdesaoListagemBotoesAcoes.vue?vue&type=template&id=2520b7be&scoped=true"
import script from "./AnexoAdesaoListagemBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./AnexoAdesaoListagemBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520b7be",
  null
  
)

export default component.exports